import { actionTypes } from '../../../actions/constants';
import { vipCuratedFolderRule } from './vipCuratedFolderRule';

export default {
    name: 'vipCuratedFolder',
    priority: 400,
    rule: vipCuratedFolderRule,
    action: () => (dispatch: (arg: { type: string }) => void) =>
        dispatch({ type: actionTypes.TOGGLE_VIP_CURATED_FOLDER_TOOLTIP_STATE }),
};
